/* Pantheratec Homepage: show real Fera store rating already present in the announcement bar.
   No second Fera widget, fabricated values, network requests or review count defaults. */
(function () {
  'use strict';

  function init() {
    var hero = document.querySelector('[data-pt-home-proof]');
    var source = document.querySelector('[data-pt-announce-fera]');
    if (!hero || !source || hero.dataset.ptHomeProofReady === '1') return;

    var scoreOutput = hero.querySelector('[data-pt-home-score]');
    var countOutput = hero.querySelector('[data-pt-home-count]');
    var starsOutput = hero.querySelector('[data-pt-home-stars]');
    var sourceDisplay = source.querySelector('[data-pt-fera-display]');
    var sourceScore = source.querySelector('[data-pt-fera-score]');
    var sourceCount = source.querySelector('[data-pt-fera-count]');
    if (!scoreOutput || !countOutput || !starsOutput || !sourceDisplay || !sourceScore || !sourceCount) return;

    hero.dataset.ptHomeProofReady = '1';

    function sync() {
      var scoreString = (sourceScore.textContent || '').trim();
      var countString = (sourceCount.textContent || '').replace(/\s+/g, ' ').trim();
      var score = parseFloat(scoreString.replace(',', '.'));
      var count = Number((countString.match(/[\d.,]+/) || [''])[0].replace(/[^\d]/g, ''));
      if (sourceDisplay.hidden || !Number.isFinite(score) || score < 1 || score > 5 || !Number.isFinite(count) || count < 1) {
        hero.hidden = true;
        return;
      }
      scoreOutput.textContent = scoreString;
      countOutput.textContent = countString;
      starsOutput.style.width = (score / 5 * 100).toFixed(2) + '%';
      hero.setAttribute('aria-label', 'Fera-Shopbewertungen: ' + scoreString + ' von 5 Sternen, ' + countString);
      hero.hidden = false;
    }

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sync();
      });
    });
    observer.observe(source, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden']});
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
